import styled from 'styled-components';

import { colors } from '../../../constants';

interface StyledRadioProps {
  error?: boolean;
  selected?: boolean;
}

export const RadioRow = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  margin-right: 1.5rem;
`;

export const OuterCircle = styled.button<StyledRadioProps>`
  display: flex;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 6.25rem;
  border: 0.125rem solid #909090;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  cursor: pointer;
  transition: all 0.1s ease;

  ${(button: StyledRadioProps) =>
    button.error &&
    `
      border: 0.125rem solid ${colors.TEXT_ERROR};
    `};

  /* Hover/Focus - add orange background, border, and font color */
  &:hover,
  &:focus {
    border: 0.125rem solid ${colors.UI_OUTLINE};
    ${(button: StyledRadioProps) =>
      button.selected &&
      `
      border: 0.125rem solid ${colors.BORDER_TERTIARY};
    `};
  }

  /* Undo on-focus UI if focus-visible property is supported */
  &:focus:not(:hover) {
    border: 0.125rem solid ${colors.BORDER_TERTIARY};
    ${(button: StyledRadioProps) =>
      button.selected &&
      `
      border: 0.125rem solid ${colors.UI_OUTLINE};
    `};
  }

  /* Apply on-focus UI only when keyboard-focused - Follows Prosper's new Shape Design System */
  &:focus-visible {
    border: 0.125rem solid ${colors.UI_OUTLINE};
  }

  ${(button: StyledRadioProps) =>
    button.selected &&
    `
      border: 0.125rem solid ${colors.UI_OUTLINE};
    `};
`;

export const FillCircle = styled.div<StyledRadioProps>`
  width: 0.875rem;
  height: 0.875rem;
  border-radius: 6.25rem;
  background-color: transparent;

  ${(div: StyledRadioProps) =>
    div.selected &&
    `
    background-color: ${colors.UI_OUTLINE};
    `};

  /* Hover/Focus - add orange background, border, and font color */
  &:hover,
  &:focus {
    background-color: ${colors.UI_OUTLINE};
    ${(div: StyledRadioProps) =>
      div.selected &&
      `
          background-color: transparent;
        `};
  }

  /* Undo on-focus UI if focus-visible property is supported */
  &:focus:not(:hover) {
    background-color: transparent;
    ${(div: StyledRadioProps) =>
      div.selected &&
      `
        background-color: ${colors.UI_OUTLINE};
      `};
  }

  /* Apply on-focus UI only when keyboard-focused - Follows Prosper's new Shape Design System */
  &:focus-visible {
    background-color: ${colors.UI_OUTLINE};
  }
`;

export const Label = styled.p`
  font-size: 1rem;
  line-height: 1.375rem;
  color: ${colors.TEXT_INPUT};
  min-width: 4rem;
`;
